import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  params = Object.assign(params, {
    includes: 'partner,total',
  });
  return request(`v1/api/partner/stores?${stringify(params)}`);
}

export async function get(id, params = {}) {
  if (params) {
    return request(`v1/api/partner/stores/${id}?${stringify(params)}`);
  }
  return request(`v1/api/partner/stores/${id}`);
}

export async function create(body) {
  return request(`v1/api/partner/stores`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`v1/api/partner/stores/${id}`, {
    method: 'POST',
    body,
  });
}
export async function sync(body) {
  return request(`/partner/sync-stores`, {
    method: 'POST',
    body,
  });
}
